import app from 'flarum/forum/app';
app.initializers.add('val-ui-legacy-rule-anchors', () => {
  /*
   * Compatibilité avec les anciennes ancres phpBB.
   * Les vieux liens /app.php/rules#... pourront être redirigés vers
   * /p/1-regles-du-forum#... sans perdre leur destination précise.
   */
  const aliases = {
    'regle-1b': 'contenu-2',
    'regle-2a': 'comportement-1',
    'regle-3a': 'sujets-messages-forums-1',
    'regle-3b': 'redaction-des-titres-regle-1',
    'regle-3c': 'sujets-messages-forums-2',
    'regle-3d': 'sujets-messages-forums-3',
    'regle-3e': 'sujets-messages-forums-4',
    'regle-3f': 'sujets-messages-forums-5',
    'trolls': 'comportement-5'
  };
  let timer = null;
  let lastScrolledUrl = null;
  function isRulesPage() {
    return /^\/p\/1-regles-du-forum\/?$/.test(window.location.pathname);
  }
  function installAliases() {
    if (!isRulesPage()) {
      return;
    }
    Object.entries(aliases).forEach(function (_ref) {
      let [oldId, currentId] = _ref;
      if (document.getElementById(oldId)) {
        return;
      }
      const target = document.getElementById(currentId);
      if (!target || !target.parentNode) {
        return;
      }
      const anchor = document.createElement('span');
      anchor.id = oldId;
      anchor.className = 'val-legacy-rule-anchor';
      anchor.setAttribute('aria-hidden', 'true');

      /*
       * L'ancre reste totalement invisible et ne modifie pas
       * la mise en page.
       */
      anchor.style.display = 'block';
      anchor.style.height = '0';
      anchor.style.overflow = 'hidden';
      target.parentNode.insertBefore(anchor, target);
    });
    const hash = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    if (!hash) {
      return;
    }
    const targetId = aliases[hash] || hash;
    const target = document.getElementById(targetId);
    if (!target || lastScrolledUrl === window.location.href) {
      return;
    }
    lastScrolledUrl = window.location.href;

    /*
     * La page Flarum est rendue après le chargement initial.
     * On force donc le positionnement une fois la cible présente.
     */
    window.requestAnimationFrame(function () {
      target.scrollIntoView({
        block: 'start'
      });
    });
  }
  function scheduleInstall() {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      installAliases();
    }, 50);
  }
  window.addEventListener('load', scheduleInstall);
  window.addEventListener('hashchange', scheduleInstall);
  window.addEventListener('popstate', scheduleInstall);
  new MutationObserver(scheduleInstall).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  scheduleInstall();
});